// src/pages/dashboard/wallet-detail/shared/WalletQRModal.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { copyToClipboard } from './wallet-utils';
import '../../../../assets/styles/wallet-detail-button.css'; // Importamos los estilos de botones
import { getNetworkInfo, getWarningMessageKey } from '../../../../utils/cryptoNetworkUtils';

interface WalletQRModalProps {
  address: string | undefined;
  qrCodeData: string | null;
  currency?: string;
  network?: string;
  onClose: () => void;
}

export default function WalletQRModal({ address, qrCodeData, currency, network, onClose }: WalletQRModalProps) {
  const { t } = useTranslation();

  // Get network info if currency and network are provided
  const networkInfo = currency && network ? getNetworkInfo(currency, network) : null;
  const messageKey = networkInfo ? getWarningMessageKey(networkInfo) : null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '30px',
        borderRadius: '10px',
        width: '90%',
        maxWidth: '450px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}>
        <h3 style={{ marginBottom: '20px', fontSize: '20px' }}>{t('wallets.qrCode')}</h3>

        {qrCodeData ? (
          <img
            src={qrCodeData}
            alt="Wallet QR Code"
            style={{ width: '200px', height: '200px', marginBottom: '20px' }}
          />
        ) : (
          <div style={{ width: '200px', height: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <p>Loading QR code...</p>
          </div>
        )}

        <p style={{
          fontSize: '14px',
          color: '#666',
          marginBottom: '12px',
          wordBreak: 'break-all',
          textAlign: 'center',
          fontFamily: 'monospace'
        }}>
          {address}
        </p>

        {/* Network Warning */}
        {networkInfo && messageKey && (
          <div style={{
            width: '100%',
            backgroundColor: '#fef3c7',
            borderLeft: '4px solid #f59e0b',
            padding: '16px',
            marginBottom: '20px',
            borderRadius: '4px'
          }}>
            <div style={{ display: 'flex' }}>
              <div style={{ flexShrink: 0 }}>
                <svg style={{ height: '20px', width: '20px', color: '#f59e0b' }} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='currentColor'>
                  <path fillRule='evenodd' d='M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z' clipRule='evenodd' />
                </svg>
              </div>
              <div style={{ marginLeft: '12px' }}>
                <p style={{ fontSize: '14px', color: '#92400e', fontWeight: '600', marginBottom: '4px' }}>
                  {t(`wallets.qrWarning.${messageKey}`, {
                    tokenName: networkInfo.tokenName,
                    networkName: networkInfo.networkName
                  })}
                </p>
                <p style={{ fontSize: '12px', color: '#b45309', margin: 0 }}>
                  {t('wallets.qrWarning.permanentLoss')}
                </p>
              </div>
            </div>
          </div>
        )}

        <button
          onClick={onClose}
          className="wallet-btn wallet-btn-default"
        >
          Close
        </button>
      </div>
    </div>
  );
}